import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const AgreementSubmitted = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { url, date } = location.state || {};

  useEffect(() => {
    // Prevent going back
    const handlePopState = (event) => {
      navigate('/', { replace: true });
    };

    // Adding the event listener
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);

  if (!url || !date) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p className="text-red-500">Invalid request. Redirecting...</p>
        {setTimeout(() => navigate('/'), 2000)}
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gray-100 text-center px-4">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-lg">
        <h1 className="text-2xl font-bold text-green-600">
          Agreement Submitted Successfully 🎉
        </h1>
        <p className="mt-2 text-gray-600">
          Your agreement was submitted on{' '}
          <span className="font-semibold">{new Date(date).toDateString()}</span>
          .
        </p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-block bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
        >
          📄 Click here to View
        </a>
      </div>
    </div>
  );
};

export default AgreementSubmitted;
